import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const helpBtn = theme => css`
  padding: ${rem(3)} ${rem(16)} ${rem(3)} ${rem(11)};
  background-color: ${theme.color.monochrome.white};
  border-radius: ${rem(20)};

  svg {
    width: ${rem(26)};
    height: ${rem(26)};
  }

  &:hover {
    box-shadow: 0 2px 6px 0 rgba(${theme.color.monochrome.black_rgba}, 0.15);
  }
`

const header = css`
  h4 {
    margin-top: 40px !important;
  }
`
const controls = theme => css`
  button {
    width: 100%;

    + button {
      margin-top: ${theme.spacing[5]};
    }
  }
`

const fullWidth = css`
  max-width: 100%;
`

export const styles = {
  header,
  controls,
  helpBtn,
  fullWidth,
}
